export default __webpack_public_path__ + "static/media/jf-submit-bl.29b6b4b2.svg";